<template>
    <div>
        <form class="request-image-form" @submit.prevent="sendRequest" @keydown="form.onKeydown($event)">
            <div class="form-row">
                <div class="form-group col-sm-12">
                    <label class="required">Message</label>
                    <textarea v-model="form.message" rows="4" :class="{ 'is-invalid': form.errors.has('message') }" type="text" name="message" class="form-control"
                              placeholder="Add description here..."
                    />
                    <has-error :form="form" field="message"/>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-12 col-sm-6">
                    <label class="required">Contact Email</label>
                    <input v-model="form.email" :class="{ 'is-invalid': form.errors.has('email') }" type="text" name="email" class="form-control">
                    <has-error :form="form" field="email"/>
                </div>
                <div class="form-group col-12 col-sm-6">
                    <label class="required">Name</label>
                    <input v-model="form.name" :class="{ 'is-invalid': form.errors.has('name') }" type="text" name="name" class="form-control">
                    <has-error :form="form" field="name"/>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-12 col-sm-6">
                    <label>Company</label>
                    <input v-model="form.company" :class="{ 'is-invalid': form.errors.has('company') }" type="text" name="company" class="form-control" placeholder="(Optional)">
                    <has-error :form="form" field="company"/>
                </div>
                <div class="form-group col-12 col-sm-6">
                    <label class="required">Industry</label>
                    <b-form-select v-model="form.industry_id" :options="industries" :class="{ 'is-invalid': form.errors.has('industry_id') }" name="industry_id" class="form-control"/>
                    <has-error :form="form" field="industry_id"/>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-12">
                    <v-button :loading="form.busy" class="w-auto mt-4">Send Request</v-button>
                    <b-button v-if="showCancel" class="w-auto mt-4 btn-hollow btn-default" type="button" @click="cancel">Cancel</b-button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import Form from 'vform'
import { mapGetters } from 'vuex'

export default {
    name: 'RequestImageForm',
    props: {
        searchTerm: { type: String, default: null },
        filterOptions: { type: Object, default: null },
        showCancel: { type: Boolean, default: true }
    },
    data () {
        return {
            form: new Form({
                message: '',
                email: '',
                name: '',
                company: '',
                industry_id: null
            })
        }
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            industries: 'data/industries'
        })
    },
    watch: {
        async user (newUser, oldUser) {
            await this.setUserFields()
        }
    },
    mounted () {
        this.setUserFields()
    },
    methods: {
        setUserFields () {
            if (this.user) {
                this.form.name = `${this.user.first_name} ${this.user.last_name}`
                this.form.email = this.user.email
                this.form.company = this.user.company
                this.form.industry_id = this.user.industry_id
            }
        },
        sendRequest () {
            this.form.searchTerm = this.searchTerm
            this.form.filter_options = this.filterOptions

            this.form.post('/request')
                .then(({ data }) => {
                    this.$toast.success('Your request was submitted. We will be in touch shortly.')

                    this.form.message = ''

                    this.$emit('cancel')
                })
        },
        cancel () {
            this.$emit('cancel')
        }
    }
}
</script>
